/**
 * Created by mongoose on 14/11/17.
 */
import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ErrorContainer = styled.div`
  color: #b20e0e !important;
  background-color: #f4dbdb;
  display: inline-block;
  padding: 3px 5px;
  margin-top: 4px;
  border-radius: 5px;
`;

function FieldErrorList({ errors }) {
  if (!errors || errors.length === 0) {
    return null;
  }
  return (
    <ul className="parsley-errors-list filled">
      {errors.map((error, idx) => (
        <li key={idx} className="parsley-required">
          <ErrorContainer>{error}</ErrorContainer>
        </li>
      ))}
    </ul>
  );
}

FieldErrorList.propTypes = {
  field: PropTypes.object,
  formErrors: PropTypes.object,
  formValues: PropTypes.object,
  hasErrors: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FieldErrorList;
